<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div class="Modal_area Explanation__modal_area">
      <div class="Modal__cross-box _cross" @click="modalClose">
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner Explanation__modal_inner Explanation__modal_inner--pd_lr">
        <div class="Explanation__instructor js-accordion">
          <div
            v-for="instructor in listInstructors"
            v-show="instructor.display_status == 1"
            :key="instructor.id"
            class="Explanation__profile_box"
          >
            <div class="Explanation__profile_head">
              <div class="Explanation__profile_head_thumbnail">
                <img class="Explanation__profile_head_thumbnail_img" :src="`${instructor.image_url}`">
              </div>
              <div class="Explanation__profile_head_sub">
                <p class="Explanation__profile_head_sub_name">
                  <span class="Explanation__profile_head_sub_name_jpn">{{ instructor.name_ja }}</span>
                  <span class="Explanation__profile_head_sub_name_en" style="text-transform: uppercase;">{{ instructor.name }}</span>
                </p>
              </div>
            </div>
            <div class="Explanation__profile_bottom js-accordion-trigger" :class="{ 'is-active': activeItem[instructor.id] }" @click="toggleActive(instructor)">
              <div
                class="Explanation__profile_bottom__inner accordion__content"
                :class="{ 'is-open': activeItem[instructor.id] }"
              >
                <div class="Explanation__profile_bottom__tx_area">
                  <p class="Explanation__profile_bottom_tx">
                    {{ instructor.introduction }}
                  </p>
                  <h3 class="Explanation__profile_bottom_head">
                    &#60;休日の過ごし方・趣味&#62;
                  </h3>
                  <p class="Explanation__profile_bottom_answer">
                    {{ instructor.hobbies }}
                  </p>
                  <h3 class="Explanation__profile_bottom_head">
                    &#60;資格・職業経験&#62;
                  </h3>
                  <p class="Explanation__profile_bottom_answer">
                    {{ instructor.work_experience }}
                  </p>
                </div>
              </div>
              <div class="Explanation__profile_btn accordion__title">
                <span
                  class="Explanation__profile_btn_tx Explanation__profile_btn_close"
                >
                  閉じる
                </span>
                <span
                  class="Explanation__profile_btn_tx Explanation__profile_btn_open"
                >
                  プロフィールを見る
                </span>
              </div>
            </div>
            <div class="Explanation__profile_check">
              <label
                class="Check__box Check__box--center Check__box__lightblue _ft-spacing60"
              >
                <input
                  v-model="instructor.is_favorite_user"
                  type="checkbox"
                  name="favorite-instructor"
                  @click="changeIns(instructor.id)"
                >
                <span class="Check__box_inner" />
                <span class="Check__box_inner_tx">お気に入り登録</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout'
import instructorService from '@/services/instructorService'
export default {
  name: 'ClassInstructorListModal',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listInstructors: {},
      activeItem: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getListInstructors()
    },
    async getListInstructors() {
      const response = await instructorService.index()
      this.listInstructors = response.data
    },
    modalClose() {
      this.$emit('close')
    },
    toggleActive(item) {
      if (this.activeItem[item.id]) {
        this.removeActiveItem(item)
        return
      }
      this.addActiveItem(item)
    },
    addActiveItem(item) {
      this.activeItem = Object.assign({},
        this.activeItem,
        { [item.id]: item }
      )
    },
    removeActiveItem(item) {
      delete this.activeItem[item.id]
      this.activeItem = Object.assign({}, this.activeItem)
    },
    changeIns(id) {
      this.$emit('changeIntructor', id)
    }
  }
}
</script>
